import React from 'react';
import './ModalLoader.scss';

interface ModalLoaderProps {
  size?: 'small' | 'medium' | 'large';
}

export const ModalLoader: React.FC<ModalLoaderProps> = ({ size = 'medium' }) => {
  return (
    <div className={`modal-loader modal-loader--${size}`}>
      <div className="loader-spinner"></div>
    </div>
  );
};
